<div class="progress" style="height: 30px">
  <div class="progress-bar" role="progressbar" [style.width.%]="(percentageValue / baseValue) * 100"></div>
  <span class="progress-text p-1 d-block">
    <ng-container *ngTemplateOutlet="barValueTemplate"></ng-container>
  </span>
</div>
